import { Injectable, NgZone } from '@angular/core';
import { UserService } from './user.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AppURLType } from '@shared/common';

declare var device;
function _window(): any {
	return window;
}

@Injectable({
	providedIn: 'root',
})
export class NavigateService {
	constructor(
		private userService: UserService,
		public snackBar: MatSnackBar,
		private router: Router,
		private location: Location,
		private zone: NgZone
	) {}

	navigateMobile(params: any) {
		if (!params) {
			params = JSON.parse(this.getParamsToStorage());
		}
		//alert(JSON.stringify(params));
		const controller = params['controller'];
		const action = params['action'];
		const param = params['params'];
		const type = params['type'];
		let navigateLink = controller + '/' + action + '/';
		switch (type) {
			case 'JobDetails':
				navigateLink += param;
				break;
			case 'TaskDetail':
				const taskid = params['taskid'];
				navigateLink = '/task/' + taskid;
				break;
			case 'WorkOrderDetail':
				const woid = params['woid'];
				navigateLink = '/workorder/' + woid + '/view/detail';
				break;
			case 'timeoffevent':
				navigateLink = '/hours/time-off/' + params['tab'] + '/detail?id=' + params['id'];
				break;
		}

		this.removeParamsToStorage();
		setTimeout(() => {
			if (this.userService.IsJobtitleAvailable() == true) {
				this.location.replaceState('home/nonhourly');
			} else {
				this.location.replaceState('home/hourly');
			}
			this.sendNavigateWithParamInUrl(navigateLink);
		}, 1000);
	}

	setParamsToStorage(params: any) {
		sessionStorage.setItem('navigate-params', JSON.stringify(params));
	}

	getParamsToStorage(): string {
		return sessionStorage.getItem('navigate-params') || '';
	}

	removeParamsToStorage() {
		return sessionStorage.removeItem('navigate-params');
	}

	getAppURLType(url: URL): AppURLType {
		const type = url.searchParams.get('type');
		if (type) {
			switch (type.toLowerCase()) {
				case 'jobdetails':
					return AppURLType.job;
				case 'taskdetail':
					return AppURLType.task;
				case 'workorderdetail':
					return AppURLType.workOrder;
				case 'timeoffevent':
					return AppURLType.timeoff;
				default:
					return AppURLType.unknown;
			}
		}
		return AppURLType.unknown;
	}

	/**
	 * Send navigating with param in url
	 */
	sendNavigateWithParamInUrl(url) {
		var fragment = url.split('#');
		var fragmentStr = fragment.length > 1 ? fragment[1] : null;
		var urlParse = fragment[0].split('?');
		var link = urlParse[0];
		var params = {};
		if (urlParse.length > 1) {
			var values = urlParse[1].split('&');
			for (var i = 0; i < values.length; i++) {
				var value = values[i].split('=');
				if (value.length == 2 && value[0] != '') {
					params[value[0]] = value[1];
				}
			}
		}

		this.zone.run(() => {
			this.router.navigate([link], { queryParams: params, fragment: fragmentStr });
		});
	}

	/**
	 * Get navigating path from href of view detail button
	 * @param: href: string
	 * @returns path for navigating
	 */
	getPath(href: string): string {
		if (href) {
			let url = new URL(href);
			if (url) {
				let type = this.getAppURLType(url);
				switch (type) {
					case AppURLType.job:
						let fullJobPath = href.split('navigate-details/')[1];
						if (fullJobPath) {
							let jobPath = fullJobPath.split('?')[0];
							if (jobPath) {
								return jobPath;
							}
						}
						break;
					case AppURLType.task:
						let taskid = url.searchParams.get('taskid');
						let taskPath = 'task/' + taskid;
						return taskPath;
					case AppURLType.workOrder:
						let woid = url.searchParams.get('woid');
						let woPath = 'workorder/' + woid + '/view/detail';
						return woPath;
					case AppURLType.timeoff:
						let link = '/hours/time-off/' + url.searchParams.get('tab') + '/detail?id=' + url.searchParams.get('id');
						return link;
					default:
						return href;
				}
			}
		}
		return href;
	}
}
